import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviousAddressComponent } from './previous-address.component';
import {ReservationService} from '../../trip-reservations/reservations.service';
import {AgGridModule} from 'ag-grid-angular/src/aggrid.module';
import {DirectivesModule} from '../../../directives/directives.module';

@NgModule({
  imports: [
    CommonModule,
    AgGridModule.withComponents([]),
    DirectivesModule
  ],
  declarations: [PreviousAddressComponent],
  exports: [PreviousAddressComponent],
  providers: [ReservationService]
})
export class PreviousAddressModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/previous-address/previous-address.module.ts